/**
 * @typedef {Object} WebhookDTO
 * @property {string} id - Webhook ID
 * @property {string} name - Webhook name
 * @property {string} webHookType - Type of webhook
 * @property {string} endPointUrl - Webhook endpoint URL
 * @property {boolean} enabled - Whether the webhook is enabled
 */

/**
 * @typedef {Object} SellerWebhookDTO
 * @property {string} id - Seller webhook ID
 * @property {string} ringbaWebhookId - Ringba webhook ID
 * @property {string} webhookUrl - Webhook URL
 * @property {boolean} enabled - Whether the webhook is enabled
 * @property {string} createdAt - Creation timestamp
 * @property {string|null} updatedAt - Last update timestamp
 * @property {Object} fieldMapping - Field mapping configuration
 * @property {Object} extraParams - Additional parameters
 */

import httpClient from './httpClient'

const END_POINT = '/customerresources/seller'

const SellerWebhooksAPI = {

  /**
   * Get all webhooks configured in the seller's Ringba account
   * @param {string} accountId - The seller account ID
   * @returns {Promise<{data: WebhookDTO[]}>} Promise resolving to array of webhooks
   */
  async listRingbaWebhooks(accountId) {
    return await httpClient.get(`${END_POINT}/${accountId}/ringba-webhooks`)
  },

  /**
   * Select an existing webhook from the seller's Ringba account
   * @param {string} accountId - The seller account ID
   * @param {string} ringbaWebhookId - The Ringba webhook ID to select
   * @returns {Promise<{data: SellerWebhookDTO}>} Promise resolving to the saved webhook
   */
  async selectWebhook(accountId, ringbaWebhookId) {
    return await httpClient.post(`${END_POINT}/${accountId}/ringba-webhooks/select`, {
      ringbaWebhookId
    })
  },

  /**
   * Get the saved webhook configuration for a seller account
   * @param {string} accountId - The seller account ID
   * @returns {Promise<{data: SellerWebhookDTO}>} Promise resolving to the seller's webhook
   */
  async getSellerWebhook(accountId) {
    return await httpClient.get(`${END_POINT}/${accountId}/webhook`)
  }
}

export default SellerWebhooksAPI
